import styled from "styled-components";
import RangeSlider from "react-bootstrap-range-slider";


export const ModalKettleContainer = styled.div`
    display: flex;
  flex-direction: column;
  justify-self: center;
  max-width: 600px;
gap: 10px;    
`

export const ModalKettleSectionTemperature = styled.div`
  display: grid;
  border-radius: 15px;
  outline: 1px solid black;
  grid-template-columns: repeat(3, 1fr);
  align-items: center;
  gap: 10px;
  min-height: 70px;
  padding: 10px;
`

export const ModalKettleSectionTemperatureField = styled.div`
    display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
`
export const ModalKettleSectionTemperatureText = styled.p`
   padding: 0;
  margin: 0;
  font-size: 14px;
`
export const ModalKettleSectionHeader = styled.p`
  //max-width: min-content;
   padding: 0;
  margin: 0;
`

export const ModalKettleSectionTemperatureSubText = styled.p`
   padding: 0;
  margin: 0;
  font-size: 12px;
  color: gray;
`

export const ModalKettleSectionMode = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  gap: 10px;
  width: 100%;
`

export const ModalKettleSectionSettings = styled(ModalKettleSectionMode)`
`

export const ModalKettleSection = styled.div`
  border-radius: 15px;
  outline: 1px solid black;
  padding: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  justify-items: center;
  align-items: center;
  gap: 10px;
`

export const ModalKettleButton = styled.div`
  display: flex;
  gap: 10px;
  @media (max-width: 760px) {
    button {
      &:hover {
        background: transparent;
        color: #198754;
      }
    }
  }
`

export const ModalKettleRange = styled.div`
  display: flex;
  width: 100%;
    span {
      width: 100%;
      input {
        width: 100% !important;
      }
    }
`
